"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
function DateContainer() {
    var t = (0, react_i18next_1.useTranslation)().t, _a = (0, react_1.useState)({
        day_name: "",
        date_number: "",
        month_name: "",
    }), currentDate = _a[0], setCurrentDate = _a[1];
    (0, react_1.useEffect)(function () {
        var dateDay = new Date(), day_name = (0, moment_1.default)(dateDay).format("dddd"), month_name = (0, moment_1.default)(dateDay).format("MMMM"), date_number = (0, moment_1.default)(dateDay).format("DD");
        setCurrentDate({
            day_name: day_name,
            month_name: month_name,
            date_number: date_number,
        });
    }, []);
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            flex: 0.6,
            alignItems: "center",
        } },
        react_1.default.createElement("div", { className: "headerText" },
            t(currentDate.day_name),
            ",",
            t(currentDate.date_number),
            " ",
            t(currentDate.month_name))));
}
exports.default = DateContainer;
